const GlossaryTermConfig = {
  collection: "glossary_terms",
  fields: [
    "id",
    "name",
    "disclaimer",
    "locale.language",
    "locale.headline",
    "locale.body",

    "locale.language",
    "locale.headline"
  ],

  filter: "filter[status][_eq]=active",

  adapter: class GlossaryTerm {
    constructor(glossaryTerm) {
      this.id = glossaryTerm.id;
      this.name = glossaryTerm.name;
      this.disclaimer = glossaryTerm.disclaimer?.id;

      this.html_id = `glossary-term_${this.id}`;

      let locale = glossaryTerm.locale ? glossaryTerm.locale[0] : null;
      if (!locale) return;

      this.headline = locale.headline;
      this.body = locale.body;
    }

    map(collections, maps) {
      this.disclaimer = maps.disclaimers[this.disclaimer];
    }
  }
};

export default GlossaryTermConfig;
